document.addEventListener('DOMContentLoaded',function(){
  const navToggle=document.getElementById('navToggle');
  const siteNav=document.getElementById('siteNav');
  if(navToggle&&siteNav){navToggle.addEventListener('click',()=>siteNav.classList.toggle('open'))}
  document.querySelectorAll('.nav-item.has-dropdown').forEach(function(item){
    const toggle=item.querySelector('.nav-dropdown-toggle');
    const label=item.querySelector('.nav-link');
    if(!toggle)return;
    const toggleDropdown=function(e){
      e.preventDefault();
      const isOpen=item.classList.contains('dropdown-open');
      document.querySelectorAll('.nav-item.has-dropdown.dropdown-open').forEach(function(open){
        if(open!==item){open.classList.remove('dropdown-open');const t=open.querySelector('.nav-dropdown-toggle');if(t)t.setAttribute('aria-expanded','false')}
      });
      item.classList.toggle('dropdown-open',!isOpen);
      toggle.setAttribute('aria-expanded',String(!isOpen));
    };
    toggle.addEventListener('click',toggleDropdown);
    if(label)label.addEventListener('click',toggleDropdown);
  });
  document.addEventListener('click',function(e){
    document.querySelectorAll('.nav-item.has-dropdown.dropdown-open').forEach(function(item){
      if(!item.contains(e.target)){
        item.classList.remove('dropdown-open');
        const t=item.querySelector('.nav-dropdown-toggle');if(t)t.setAttribute('aria-expanded','false');
      }
    });
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      document.querySelectorAll('.nav-item.has-dropdown.dropdown-open').forEach(function(item){
        item.classList.remove('dropdown-open');
        const t=item.querySelector('.nav-dropdown-toggle');if(t)t.setAttribute('aria-expanded','false');
      });
    }
  });
  const scrollTop=document.getElementById('scrollTop');
  if(scrollTop){window.addEventListener('scroll',()=>scrollTop.classList.toggle('visible',window.scrollY>400))}
  const canvas=document.getElementById('heroParticles');
  if(canvas){spawnParticles(canvas)}
  const mainImage=document.getElementById('mainImage');
  const galleryPrev=document.getElementById('galleryPrev');
  const galleryNext=document.getElementById('galleryNext');
  if(mainImage&&window.productImages&&window.productImages.length>1){
   let idx=0;
    const showImage=function(i,dir){
      const newIdx=(i+window.productImages.length)%window.productImages.length;
      if(newIdx===idx)return;
      const direction=dir||(newIdx>idx?1:-1);
      mainImage.style.transition='transform .3s ease';
      mainImage.style.transform=direction>0?'translateX(-100%)':'translateX(100%)';
      setTimeout(()=>{
        mainImage.style.transition='none';
        mainImage.src=window.productImages[newIdx];
        mainImage.style.transform=direction>0?'translateX(100%)':'translateX(-100%)';
        void mainImage.offsetWidth;
        mainImage.style.transition='transform .3s ease';
        mainImage.style.transform='translateX(0)';
        idx=newIdx;
        document.querySelectorAll('.thumb-img').forEach((t,ti)=>t.classList.toggle('active',ti===idx));
      },300);
    };
    if(galleryPrev)galleryPrev.addEventListener('click',()=>showImage(idx-1,-1));
    if(galleryNext)galleryNext.addEventListener('click',()=>showImage(idx+1,1));
    document.querySelectorAll('.thumb-img').forEach((t,ti)=>{
      t.addEventListener('click',()=>showImage(ti,ti>idx?1:-1));
    });
  }
 document.querySelectorAll('.btn-add-cart').forEach(btn=>{
    btn.addEventListener('click',async function(){
      const id=this.dataset.variantId;
      if(!id){window.location='/cart';return}
      const wrap=this.closest('.add-cart-wrap');
      const stockInfo=wrap?parseStockData(wrap.dataset.stock):null;
      if(stockInfo&&!isVariantAvailable(stockInfo)){
        showToast(getOutOfStockMessage(),'error');
        return;
      }
      const matches=document.querySelectorAll('.btn-add-cart[data-variant-id="'+id+'"]');
      matches.forEach(b=>{b.textContent='...';b.disabled=true});
      try{
        const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity:1})});
        if(r.ok){
          matches.forEach(b=>{b.textContent='✓ Added';b.style.borderColor='#b8962e';b.style.color='#b8962e'});
          await refreshCartDrawer();
          await refreshCartPage();
          openCartDrawer();
          setTimeout(()=>{
            matches.forEach(b=>{b.textContent='+ Add';b.disabled=false;b.style.borderColor='';b.style.color=''});
          },2000);
        }else{
          const err=await r.json().catch(()=>null);
          showToast((err&&err.description)||getOutOfStockMessage(),'error');
          matches.forEach(b=>{b.textContent='+ Add';b.disabled=false});
        }
      }catch(e){
        matches.forEach(b=>{b.textContent='+ Add';b.disabled=false});
      }
    });
  });
syncCartControls();
  const variantSelect=document.getElementById('variantSelect');
  if(variantSelect){
    variantSelect.addEventListener('change',syncCartControls);
    variantSelect.addEventListener('change',updateStockStatus);
  }
  updateStockStatus();
  const addBtn=document.getElementById('addToCartBtn');
  if(addBtn){
    addBtn.addEventListener('click',async function(){
      const sel=document.getElementById('variantSelect');
      const id=sel?sel.value:this.dataset.variantId;
      if(!id)return;
      const info=window.productVariantStock?window.productVariantStock[id]:null;
      if(this.disabled||(info&&!isVariantAvailable(info))){
        showToast(getOutOfStockMessage(),'error');
        return;
      }
      this.textContent='Adding...';this.disabled=true;
      try{
        const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(id),quantity:1})});
        if(r.ok){
          this.textContent='✓ Added to Vault!';await refreshCartDrawer();await refreshCartPage();openCartDrawer();
          setTimeout(()=>{this.textContent='Add to Vault';this.disabled=false;updateStockStatus()},2500)
        }else{
          const err=await r.json().catch(()=>null);
          showToast((err&&err.description)||getOutOfStockMessage(),'error');
          this.textContent='Add to Vault';this.disabled=false;
          updateStockStatus();
        }
      }catch(e){this.textContent='Add to Vault';this.disabled=false}
    });
  }
  const cartOpenBtn=document.getElementById('cartDrawerOpen');
  if(cartOpenBtn){
    cartOpenBtn.addEventListener('click',function(e){
      e.preventDefault();
      openCartDrawer();
    });
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-drawer-close]')||e.target.closest('[data-cart-drawer-overlay]')){
      closeCartDrawer();
    }
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape')closeCartDrawer();
  });
  document.addEventListener('click',async function(e){
    const cardBtn=e.target.closest('[data-card-qty-increase],[data-card-qty-decrease]');
    if(cardBtn){
      e.preventDefault();
      const wrap=cardBtn.closest('.add-cart-wrap');
      const variantId=wrap.dataset.variantId;
      const valEl=wrap.querySelector('[data-card-qty-val]');
      let qty=parseInt(valEl.textContent,10)||0;
      const increasing=cardBtn.hasAttribute('data-card-qty-increase');
      if(increasing){
        const stockInfo=parseStockData(wrap.dataset.stock);
        const remaining=stockRemaining(stockInfo);
        if(qty+1>remaining){
          showToast(getMaxQuantityMessage(remaining),'error');
          return;
        }
      }
      qty=increasing?qty+1:qty-1;
      cardBtn.disabled=true;
      try{
        await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variantId,quantity:qty})});
        await refreshCartDrawer();
        await refreshCartPage();
      }catch(err){}
      cardBtn.disabled=false;
      return;
    }
    const pageBtn=e.target.closest('[data-page-qty-increase],[data-page-qty-decrease]');
    if(pageBtn){
      e.preventDefault();
      const sel=document.getElementById('variantSelect');
      const addBtn=document.getElementById('addToCartBtn');
      const variantId=sel?sel.value:(addBtn?addBtn.dataset.variantId:null);
      if(!variantId)return;
      const valEl=document.querySelector('[data-page-qty-val]');
      let qty=parseInt(valEl.textContent,10)||0;
      const increasing=pageBtn.hasAttribute('data-page-qty-increase');
      if(increasing){
        const stockInfo=window.productVariantStock?window.productVariantStock[variantId]:null;
        const remaining=stockRemaining(stockInfo);
        if(qty+1>remaining){
          showToast(getMaxQuantityMessage(remaining),'error');
          return;
        }
      }
      qty=increasing?qty+1:qty-1;
      pageBtn.disabled=true;
      try{
        await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variantId,quantity:qty})});
        await refreshCartDrawer();
        await refreshCartPage();
      }catch(err){}
      pageBtn.disabled=false;
    }
  });
 document.addEventListener('click',async function(e){
    const qtyBtn=e.target.closest('[data-cart-qty-change]');
    if(!qtyBtn)return;
    e.preventDefault();
    const key=qtyBtn.dataset.key;
    const qty=parseInt(qtyBtn.dataset.qty,10);
    const item=qtyBtn.closest('.cart-drawer-item')||qtyBtn.closest('.cart-item');
    if(item)item.classList.add('is-updating');
    item?item.querySelectorAll('.qty-btn,.cart-item-remove').forEach(b=>b.disabled=true):qtyBtn.disabled=true;
    try{
      await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
      await refreshCartDrawer();
      await refreshCartPage();
    }catch(err){
      if(item)item.classList.remove('is-updating');
      item?item.querySelectorAll('.qty-btn,.cart-item-remove').forEach(b=>b.disabled=false):qtyBtn.disabled=false;
    }
  });
  const cards=document.querySelectorAll('.product-card');
  const obs=new IntersectionObserver(entries=>{
    entries.forEach(e=>{if(e.isIntersecting){e.target.style.opacity='1';e.target.style.transform='translateY(0)';obs.unobserve(e.target)}})
  },{threshold:0.1});
  cards.forEach((c,i)=>{
    c.style.opacity='0';c.style.transform='translateY(20px)';
    c.style.transition=`opacity .4s ease ${i*.05}s,transform .4s ease ${i*.05}s,border-color .25s ease,box-shadow .25s ease`;
    obs.observe(c);
  });

  /* ---- Premium polish: scroll-reveal for section-level elements ---- */
  var revealSelectors='.section-header,.category-card,.promo-inner,.about-value-card,.about-team-card,.about-stat,.about-story-media,.about-story-text,.about-cta-box,.contact-detail,.cart-summary-inner';
  var revealEls=document.querySelectorAll(revealSelectors);
  if(revealEls.length){
    var revealObs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){e.target.style.opacity='1';e.target.style.transform='translateY(0)';revealObs.unobserve(e.target)}
      });
    },{threshold:0.12});
    revealEls.forEach(function(el,i){
      if(el.dataset.revealed)return;
      el.style.opacity='0';
      el.style.transform='translateY(24px)';
      el.style.transition='opacity .6s cubic-bezier(.16,1,.3,1) '+((i%4)*.08)+'s,transform .6s cubic-bezier(.16,1,.3,1) '+((i%4)*.08)+'s';
      revealObs.observe(el);
    });
  }

  /* ---- Premium polish: header intensifies on scroll ---- */
  var siteHeader=document.querySelector('.site-header');
  if(siteHeader){
    var updateHeaderScroll=function(){siteHeader.classList.toggle('is-scrolled',window.scrollY>10)};
    window.addEventListener('scroll',updateHeaderScroll,{passive:true});
    updateHeaderScroll();
  }

  /* ---- Premium polish: subtle 3D tilt on category cards (pointer devices only) ---- */
  if(window.matchMedia('(hover: hover) and (pointer: fine)').matches){
    document.querySelectorAll('.category-card').forEach(function(card){
      card.style.transformStyle='preserve-3d';
      card.addEventListener('mousemove',function(e){
        var r=card.getBoundingClientRect();
        var x=(e.clientX-r.left)/r.width-0.5;
        var y=(e.clientY-r.top)/r.height-0.5;
        card.style.transform='translateY(-6px) rotateX('+(-y*5).toFixed(2)+'deg) rotateY('+(x*5).toFixed(2)+'deg)';
      });
      card.addEventListener('mouseleave',function(){card.style.transform='';});
    });
  }
});
async function updateCartCount(){
  try{const r=await fetch('/cart.js');const c=await r.json();const b=document.querySelector('.cart-count');if(b)b.textContent=c.item_count}catch(e){}
}
function openCartDrawer(){
  const drawer=document.getElementById('cartDrawer');
  if(!drawer)return;
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden','false');
  document.body.classList.add('cart-drawer-locked');
}
function closeCartDrawer(){
  const drawer=document.getElementById('cartDrawer');
  if(!drawer)return;
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden','true');
  document.body.classList.remove('cart-drawer-locked');
}
async function refreshCartDrawer(){
  try{
    const url=window.location.pathname+'?section_id=cart-drawer';
    const r=await fetch(url);
    const html=await r.text();
    const wrapper=document.getElementById('shopify-section-cart-drawer');
    if(wrapper){wrapper.outerHTML=html}
updateCartCount();
    syncCartControls();
  }catch(e){}
}
async function refreshCartPage(){
  const dynamic=document.getElementById('cartPageDynamic');
  if(!dynamic)return;
  try{
    const r=await fetch(window.location.pathname+window.location.search,{headers:{'X-Requested-With':'XMLHttpRequest'}});
    const html=await r.text();
    const parsed=new DOMParser().parseFromString(html,'text/html');
    const freshDynamic=parsed.getElementById('cartPageDynamic');
    if(freshDynamic){
      dynamic.innerHTML=freshDynamic.innerHTML;
    }
  }catch(e){}
}
async function syncCartControls(){
  try{
    const r=await fetch('/cart.js');
    const cart=await r.json();
    const qtyByVariant={};
    cart.items.forEach(i=>{qtyByVariant[i.variant_id]=(qtyByVariant[i.variant_id]||0)+i.quantity});

    document.querySelectorAll('.add-cart-wrap[data-variant-id]').forEach(wrap=>{
      const vid=parseInt(wrap.dataset.variantId,10);
      const qty=qtyByVariant[vid]||0;
      const btn=wrap.querySelector('.btn-add-cart');
      const stepper=wrap.querySelector('[data-card-stepper]');
      const val=wrap.querySelector('[data-card-qty-val]');
      if(qty>0){
        if(btn)btn.hidden=true;
        if(stepper)stepper.hidden=false;
        if(val)val.textContent=qty;
      }else{
        if(btn)btn.hidden=false;
        if(stepper)stepper.hidden=true;
      }
    });

    const pageStepper=document.querySelector('[data-page-stepper]');
    if(pageStepper){
      const sel=document.getElementById('variantSelect');
      const addBtn=document.getElementById('addToCartBtn');
      const vid=parseInt(sel?sel.value:(addBtn?addBtn.dataset.variantId:0),10);
      const qty=qtyByVariant[vid]||0;
      const val=document.querySelector('[data-page-qty-val]');
      if(qty>0){
        if(addBtn)addBtn.hidden=true;
        pageStepper.hidden=false;
        if(val)val.textContent=qty;
      }else{
        if(addBtn)addBtn.hidden=false;
        pageStepper.hidden=true;
      }
    }
  }catch(e){}
}
function updateStockStatus(){
  const sel=document.getElementById('variantSelect');
  const addBtn=document.getElementById('addToCartBtn');
  const vid=sel?sel.value:(addBtn?addBtn.dataset.variantId:null);
  const info=vid&&window.productVariantStock?window.productVariantStock[vid]:null;

  if(addBtn){
    const available=isVariantAvailable(info);
    addBtn.disabled=!available;
    addBtn.toggleAttribute('aria-disabled',!available);
    if(!available){
      addBtn.textContent='Sold Out';
    }else if(addBtn.dataset.priceLabel){
      addBtn.textContent=addBtn.dataset.priceLabel;
    }
  }

  const el=document.querySelector('[data-stock-status]');
  if(!el||!info||!info.tracked){if(el)el.style.display='none';return}
  const lowThreshold=parseInt(el.dataset.lowThreshold,10)||0;
  el.style.display='';
  if(info.quantity>0){
    if(info.quantity<=lowThreshold){
      el.innerHTML='<span class="stock-low">'+el.dataset.lowMsg.replace('[count]',info.quantity)+'</span>';
    }else{
      el.innerHTML='<span class="stock-in">'+el.dataset.inMsg.replace('[count]',info.quantity)+'</span>';
    }
  }else if(isVariantAvailable(info)){
    el.innerHTML='<span class="stock-in">Available</span>';
  }else{
    el.innerHTML='<span class="stock-out">'+el.dataset.outMsg+'</span>';
  }
}
function parseStockData(raw){
  if(!raw)return null;
  try{return JSON.parse(raw)}catch(e){return null}
}
function isVariantAvailable(info){
  if(!info)return true;
  if(window.shopSettings&&window.shopSettings.enforceStrictStock&&info.tracked){
    return info.quantity>0;
  }
  return info.available!==false;
}
function stockRemaining(info){
  if(!info||!info.tracked)return Infinity;
  return info.quantity;
}
function getOutOfStockMessage(){
  return (window.shopSettings&&window.shopSettings.outOfStockMessage)||'This product is currently out of stock.';
}
function getMaxQuantityMessage(remaining){
  const tpl=(window.shopSettings&&window.shopSettings.maxQuantityMessage)||"Only [count] left in stock — that's the most we've got!";
  return tpl.replace('[count]',remaining);
}
function showToast(message,type){
  if(!message)return;
  const container=document.getElementById('toastContainer');
  if(!container)return;
  const toast=document.createElement('div');
  toast.className='toast'+(type?' toast--'+type:'');
  toast.setAttribute('role','status');
  const icon=type==='error'?'⚠':(type==='success'?'✓':'ℹ');
  toast.innerHTML='<span class="toast__icon">'+icon+'</span><span class="toast__msg"></span><button type="button" class="toast__close" aria-label="Dismiss">&times;</button>';
  toast.querySelector('.toast__msg').textContent=message;
  container.appendChild(toast);
  requestAnimationFrame(()=>{requestAnimationFrame(()=>toast.classList.add('toast--visible'))});
  const dismiss=function(){
    if(toast.dataset.dismissed)return;
    toast.dataset.dismissed='1';
    toast.classList.remove('toast--visible');
    toast.classList.add('toast--leaving');
    setTimeout(()=>toast.remove(),320);
  };
  const timer=setTimeout(dismiss,4200);
  toast.querySelector('.toast__close').addEventListener('click',function(){clearTimeout(timer);dismiss()});
}
function spawnParticles(container){
  const COLORS=['#b8962e','#d4b04a','#f0c840','#8a6a18'];
  for(let i=0;i<35;i++){
    const p=document.createElement('div');
    p.style.cssText=`position:absolute;width:${Math.random()*3+1}px;height:${Math.random()*3+1}px;border-radius:50%;background:${COLORS[Math.floor(Math.random()*4)]};left:${Math.random()*100}%;top:${Math.random()*100}%;opacity:0;animation:particleFade ${Math.random()*4+3}s ease-in-out ${Math.random()*6}s infinite;pointer-events:none`;
    container.appendChild(p);
  }
  if(!document.getElementById('particle-style')){
    const s=document.createElement('style');s.id='particle-style';
    s.textContent='@keyframes particleFade{0%,100%{opacity:0;transform:translateY(0) scale(1)}30%{opacity:.7}60%{opacity:.4;transform:translateY(-20px) scale(1.2)}}';
    document.head.appendChild(s);
  }
}